module.exports = __webpack_public_path__ + "img/logo.e91fe573.svg";